"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalJob = void 0;
var react_1 = __importDefault(require("react"));
var job_1 = require("app/hook/job");
var voucher_1 = require("app/hook/voucher");
var job_2 = require("app/hook/job");
var external_1 = require("remota-client/page/component/external");
var ExternalJob = function (props) {
    var jobId = props.match.params.jobId;
    return (react_1.default.createElement(external_1.ExternalJobUploadBase, { jobId: jobId, useLoadExternalJob: job_1.useLoadExternalJob, useVoucherExternalUpload: voucher_1.useVoucherExternalUpload, useJobRun: job_2.useJobRun }));
};
exports.ExternalJob = ExternalJob;
